/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import shuffleArray from '../../utils/shuffleArray';
import { Context } from '../../context/AppContext';
import {
  Background1,
  Background1Webp,
  Background2,
  Background2Webp,
  Background3,
  Background3Webp,
  MobileBackground1,
  MobileBackground1Webp,
  MobileBackground2,
  MobileBackground2Webp,
  MobileBackground3,
  MobileBackground3Webp,
} from '../../assets/landing';

const StyledRoot = styled(Container)`
  background-color: #1a2b4e;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  @media ${props => props.theme.mediaQueries.mobile} {
    background-size: contain;
    background-position: top center;
    .Header__wrapper {
      min-height: 62px;
    }
  }
`;

const AnimatedBanner = ({ children, bannerImage, className }) => {
  const {
    media: { desktop, tablet },
    webp,
  } = useContext(Context);
  const [background, setBackgound] = useState();

  useEffect(() => {
    if (!background) {
      setBackgound(
        shuffleArray([
          {
            src: Background1Webp,
            fallback: Background1,
            mobileSrc: MobileBackground1Webp,
            mobileFallback: MobileBackground1,
          },
          {
            src: Background2Webp,
            fallback: Background2,
            mobileSrc: MobileBackground2Webp,
            mobileFallback: MobileBackground2,
          },
          {
            src: Background3Webp,
            fallback: Background3,
            mobileSrc: MobileBackground3Webp,
            mobileFallback: MobileBackground3,
          },
        ])
      );
    }
  }, []);

  return (
    <StyledRoot
      className={classNames('AnimatedBanner__root', {
        [className]: className,
      })}
      style={
        bannerImage
          ? {
              backgroundImage: `url(${bannerImage})`,
            }
          : {
              ...(background
                ? {
                    backgroundImage: `url(${
                      desktop || tablet
                        ? webp
                          ? background[0].src
                          : background[0].fallback
                        : webp
                        ? background[0].mobileSrc
                        : background[0].mobileFallback
                    })`,
                  }
                : {}),
            }
      }
    >
      {children}
    </StyledRoot>
  );
};

AnimatedBanner.propTypes = {
  children: PropTypes.node,
};

AnimatedBanner.defaultProps = {
  children: null,
};

export default AnimatedBanner;
